import { Box, Typography, useTheme, Paper } from '@mui/material';
import { memo } from 'react';

export const StatCard = memo(
  ({ label, value, icon, dotColor, subLabel, onClick }) => {
    const theme = useTheme();

    return (
      <Paper
        elevation={1}
        onClick={onClick}
        sx={{
          height: '100%',
          flex: 1,
          minWidth: 200,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          px: 1.5,
          py: 1,
          borderRadius: 2,
          cursor: onClick ? 'pointer' : 'default',
          transition: 'all 0.2s ease',
          '&:hover': {
            boxShadow: onClick ? theme.shadows[3] : theme.shadows[1],
            bgcolor: onClick ? theme.palette.action.hover : 'inherit',
          },
        }}
      >
        {icon && (
          <Box
            sx={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              bgcolor: '#E8EDFF',
              color: '#1D4ED8',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 18,
              flexShrink: 0,
            }}
          >
            {icon}
          </Box>
        )}
        <Box
          flex={1}
          sx={{
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100%',
          }}
        >
          <Typography variant='body1' color='text.secondary' fontSize={12}>
            {label}
          </Typography>
          <Box display='flex' alignItems='flex-start' mt={0.5}>
            {dotColor && (
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  bgcolor: dotColor,
                  mr: 1,
                }}
              />
            )}
            <Typography
              variant='h5'
              sx={{ lineHeight: 1.2, wordBreak: 'break-word' }}
            >
              {value}
            </Typography>
          </Box>
          {subLabel && (
            <Typography
              variant='caption'
              color='text.secondary'
              sx={{ mt: 0.5, display: 'block' }}
            >
              {subLabel}
            </Typography>
          )}
        </Box>
      </Paper>
    );
  }
);
